/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
class Module {
    #code;
    #metadata;
    constructor({ code, metadata }) {
        this.#code = code;
        this.#metadata = metadata;
    }
    code() {
        return this.#code ?? "";
    }
    metadata() {
        return this.#metadata ?? {};
    }
}
export class ModuleCache {
    #modules = {};
    get(id) {
        return this.#modules[id];
    }
    add(id, module) {
        this.#modules[id] = new Module(module);
    }
    remove(id) {
        if (!this.#modules[id]) {
            return;
        }
        delete this.#modules[id];
    }
    modules() {
        return this.#modules ?? {};
    }
    rebuild(graph) {
        if (!graph.modules) {
            return;
        }
        for (const [id, module] of Object.entries(graph.modules)) {
            this.add(id, module);
        }
    }
}
//# sourceMappingURL=module.js.map